<template>
  <div>
    <l-marker
      :lat-lng.sync="NWcoords"
      draggable
    />
    <l-marker
      :lat-lng.sync="SEcoords"
      draggable
    />
    <l-marker :lat-lng="center" />
    <l-rectangle
      :bounds="[NWcoords, SEcoords]"
      color="red"
      :fill="false"
      :weight="5"
    />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { LMarker, LRectangle } from 'vue2-leaflet'
import { MAP_CONFIG_KEY } from '@/constants'

const components = {
  LMarker, LRectangle,
}

@Component({ components })
export default class MapBoundingBox extends Vue {
  get SEcoordsLat () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.SEcoords.lat
  }

  set SEcoordsLat (value) {
    this.updateMapExtentCoords(value, 'SEcoords', 'lat')
  }

  get SEcoordsLng () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.SEcoords.lng
  }

  set SEcoordsLng (value) {
    this.updateMapExtentCoords(value, 'SEcoords', 'lng')
  }

  get NWcoordsLat () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.NWcoords.lat
  }

  set NWcoordsLat (value) {
    this.updateMapExtentCoords(value, 'NWcoords', 'lat')
  }

  get NWcoordsLng () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.extent.NWcoords.lng
  }

  set NWcoordsLng (value) {
    this.updateMapExtentCoords(value, 'NWcoords', 'lng')
  }

  get center () {
    const lat = (Number(this.NWcoordsLat) + Number(this.SEcoordsLat)) / 2
    const lng = (Number(this.NWcoordsLng) + Number(this.SEcoordsLng)) / 2
    return [lat, lng]
  }

  get NWcoords () {
    return { lat: this.NWcoordsLat, lng: this.NWcoordsLng }
  }

  set NWcoords (newValue) {
    this.NWcoordsLat = newValue.lat
    this.NWcoordsLng = newValue.lng
  }

  get SEcoords () {
    return { lat: this.SEcoordsLat, lng: this.SEcoordsLng }
  }

  set SEcoords (newValue) {
    this.SEcoordsLat = newValue.lat
    this.SEcoordsLng = newValue.lng
  }

  updateMapExtentCoords (value: number | string, ...args: ['SEcoords' | 'NWcoords', 'lat' | 'lng']) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'extent', ...args],
      value,
    })
  }
}

</script>
